import { render } from "./Tabs.vue?vue&type=template&id=1c2a3c98&scoped=true"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"

import "./Tabs.vue?vue&type=style&index=0&id=1c2a3c98&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1c2a3c98"

export default script